<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-s-custom"></i> 绘本缴费记录
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.uphon" clearable :placeholder="'请输入家长电话'" class="handle-input mr10" style="width: 15%;"></el-input>
								
								<el-input v-model="query.bname" clearable :placeholder="'请输入宝宝名称'" class="handle-input mr10" style="width: 15%;"></el-input>
								
								<el-select v-model="query.valueSABSAAI" clearable filterable :placeholder="'请选择所在幼儿园'" class="handle-select mr10"
								 style="width: 15%;">
									<el-option v-for="item in query.optionsSBASAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>
								
								<el-select v-model="query.valuePayState" clearable :placeholder="'请选择缴费类型'" class="handle-select mr10" style="width: 15%;">
									<el-option v-for="item in query.optionsPayState" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2">
									</el-option>
								</el-select>
								
								<span style="color: #333333; font-size: 13px; margin-left: 10px;">缴费时间：</span>
								<el-date-picker
									style="width: 170px;"
									value-format="yyyy-MM-dd HH:mm"
									format="yyyy-MM-dd HH:mm"
									v-model="query.time[0]"
									type="datetime"
									placeholder="选则开始时间">
								</el-date-picker>
								
								<span style="color: #333333; font-size: 13px; margin-left: 10px; margin-right: 10px;">至</span>
								
								<el-date-picker
									style="width: 170px;"
									value-format="yyyy-MM-dd HH:mm"
									format="yyyy-MM-dd HH:mm"
									v-model="query.time[1]"
									type="datetime"
									placeholder="选择结束时间">
								</el-date-picker>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"
								 @click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					
					<el-row>
						<el-col :span="21">
							<div class="grid-content bg-purple">
								<el-button type="success" :disabled="!hasPerms(buttonPerms.exportPerms)"  @click="exportExcel">导出EXCEL</el-button>
							</div>
						</el-col>
						<el-col :span="3">
							<div class="grid-content bg-purple">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.addJYTimePerms)"
								@click="handleAddJYTime">新增家长借阅时间</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
				<el-table :data="tableData" 
				 border class="table" 
				 :default-sort="{prop: 'MCBINDT', order: 'descending'}" 
				 @sort-change="changeTableSort"
				 header-cell-class-name="table-header"
				 @selection-change="handleSelectionChange" 
				 :row-key="getRowKeys" 
				 v-loading="loading" 
				 :cell-style="setCellColor">
					<!-- 序号，家长电话，宝宝名称，班级名称，所属幼儿园，缴费类型，续费前到期时间，续费后到期时间，续费金额，支付方式(微信是绿色)，获得天数，缴费时间 （可排序） -->
					<el-table-column type="index" :label="'序号'" align="center" width="60"></el-table-column>
					<el-table-column prop="HAAPHON" :label="'家长电话'" align="center"></el-table-column>
					<el-table-column prop="HABNAME" :label="'宝宝名称'" align="center"></el-table-column>
					<el-table-column prop="SABNAME" :label="'班级名称'" align="center"></el-table-column>
					<el-table-column prop="SAANAME" :label="'所属幼儿园'" align="center"></el-table-column>
					<el-table-column prop="INIDISP" :label="'缴费类型'" align="center"></el-table-column>
					<el-table-column prop="MCBSTDT" :label="'续费前到期时间'" align="center"></el-table-column>
					<el-table-column prop="MCBEDDT" :label="'续费后到期时间'" align="center"></el-table-column>
					<el-table-column prop="MCBPAYM" :label="'续费金额'" align="center" width="80"></el-table-column>
					<el-table-column prop="INIDISP2" :label="'支付方式'" align="center" width="80"></el-table-column>
					<el-table-column prop="MCBADDT" :label="'获得天数'" align="center" width="80"></el-table-column>
					<el-table-column prop="MCBINDT" :label="'缴费时间'" align="center" sortable="custom"></el-table-column>
					<el-table-column :label="'操作'" width="80" align="center">
						<template slot-scope="scope">
							<el-button type="text" 
							:disabled="!hasPerms(buttonPerms.editPerms)" 
							icon="el-icon-edit" 
							@click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper,sizes" :current-page="this.query.pageIndex"
					:page-sizes="[10, 50,100]" :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
			
			<el-dialog :title="'修改绘本到期时间'" width="40%" v-if="showEditTime"
			:visible.sync="showEditTime" :close-on-click-modal="false">
				<el-form :model="ruleForm" :rules="dataRule" ref="ruleForm"  label-width="40%">
					<el-form-item  :label="'修改前：'" prop="sEDDT">
						<el-date-picker
							:clearable="false"
							:editable="false"
							type="datetime"
							value-format="yyyy-MM-dd HH:mm"
							format="yyyy-MM-dd HH:mm"
							v-model="ruleForm.sEDDTOld"
							disabled
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					
					<el-form-item  :label="'修改后：'" prop="sEDDT">
						<el-date-picker
							:clearable="false"
							:editable="false"
							type="datetime"
							value-format="yyyy-MM-dd HH:mm"
							format="yyyy-MM-dd HH:mm"
							v-model="ruleForm.sEDDT"
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-form>
				
				<span slot="footer" class="dialog-footer">
					<el-button  @click="showEditTime = false">关闭</el-button>
					<el-button  type="primary" @click="editTime('ruleForm')">保存</el-button>
				</span>
			</el-dialog>
			<!-- 【新增家长借阅时间】 -->
			<el-dialog :title="'新增家长借阅时间'" width="40%" v-if="showJYTime" @close="onClose"
			:visible.sync="showJYTime" :close-on-click-modal="false">
				<el-form :model="ruleJYForm" :rules="dataJYRule" ref="ruleJYForm" label-width="40%">
					<el-form-item :label="'所属幼儿园：'" prop="sSAANAME">
						<el-select v-model="ruleJYForm.sSAANAME" @change="changeSAA"
						 clearable filterable :placeholder="'请选择所在幼儿园'" >
							<el-option v-for="item in ruleJYForm.optionsSAA"
							 :key="item.SAAMSID"
							 :label="item.SAANAME"
							 :value="item.SAAMSID">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="'家长电话：'" prop="sHAAPHON">
						<el-input v-model="ruleJYForm.sHAAPHON" :clearable="true" @input="handleInput($event)" :placeholder="'请输入家长电话'" 
						class="handle-input mr10" style="width: 59%;"></el-input>
					</el-form-item>
					<el-form-item :label="'宝宝名称：'" prop="sHABNAME">
						<el-select v-model="ruleJYForm.sHABNAME" @change="changeHAB"
						 clearable filterable :placeholder="'请选择宝宝名称'" >
							<el-option v-for="item in ruleJYForm.optionsHAB"
							 :key="item.HABMSID"
							 :label="item.HABNAME" 
							 :value="item.HABMSID">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item  :label="'修改前借阅到期时间：'" prop="sEDDTOld">
						<el-date-picker
							:clearable="false"
							:editable="false"
							type="datetime"
							value-format="yyyy-MM-dd HH:mm"
							format="yyyy-MM-dd HH:mm"
							v-model="ruleJYForm.sEDDTOld"
							disabled
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
					
					<el-form-item  :label="'修改后借阅到期时间：'" prop="sEDDT">
						<el-date-picker
							:clearable="false"
							:editable="false"
							type="datetime"
							value-format="yyyy-MM-dd HH:mm"
							format="yyyy-MM-dd HH:mm"
							v-model="ruleJYForm.sEDDT"
							placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="onClose()">关闭</el-button>
					<el-button type="primary" @click="editJYTime('ruleJYForm')">保存</el-button>
				</span>
			</el-dialog>
			
		</div>
	</div>
</template>
<script>
	import { hasPermission } from '@/permission/index.js'
	import { formatTimeToStr } from '../../utils/timeFormat.js'
	
	export default {
		name: 'recordList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			const checkPhone = (rule, value, callback) => {	
				if (!(/^1[34578]\d{9}$/.test(value))) {
					callback(new Error('请输入正确的手机号码'));
					this.clearFrom();
				}
				else {
					//校验手机号
				 	const self = this;
				 	var postUrl = 'WCF/WEB/svcMCA.svc/CHECK_HAA_PHONE';
				 	//网络请求接口
				 	this.$axios.post(
				 		//请求的url
				 		postUrl,
				 		//请求参数
				 		{
				 			sPHON: self.web_sphon, //web侧 登录邮箱
				 			sHAAPHON: value
				 		}
				 	)
				 	.then((response) => {
				 		//请求成功返回的数据
				 		if (response.data.KKSTR.indexOf("Y")!=-1) {
				 			console.log(1111)
							this.ruleJYForm.sHAAID = response.data.KKSTR.split('||')[1];
							console.log("手机号码存在")
							console.log("家长ID："+this.ruleJYForm.sHAAID)
				 			//已存在
				 			callback();
							this.getHABNAME();
							
				 		} else {
				 			console.log(2222)
				 			//不存在
				 			callback(new Error('手机号码不存在'));
							this.clearFrom();
				 		}

				 	})
				 	.catch((error) => {
				 		this.$message({
				 			message: '请求失败', //请求失败
				 			type: 'error'
				 		});
				 	});
				 }
			}
			return {
				//页面按钮权限
				buttonPerms: {
					exportPerms: 'record:recordList:export', //导出权限标识
					searchPerms: 'record:recordList:search', //搜索权限标识
					editPerms: 'record:recordList:edit', //编辑权限标识
					addJYTimePerms: 'record:recordList:addJYTime', //新增家长借阅时间权限标识
					disabled: false
				},
				
				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				ms_role: sessionStorage.getItem("ms_role"), //web 权限
				
				arrList: [],
				query: {
					valuePayState: '',
					optionsPayState: [],
					valueSABSAAI: '', //幼儿园名称
					optionsSBASAAI: [],
					uphon: '',
					bname: '',
					time: ['', ''],
					pageIndex: 1, //当前页
					pageSize: 10 //这是当前每页显示的条数
				},
				tableData: [],
				multipleSelection: [], // 多选操作
				delList: [],
				pageTotal: 0, // 总条数
				loading: false,
				typeAll: [],
				ULIDLabelNameFlag: true ,// 无跳转链接时删除输入框
				
				ruleForm: {
					sMSID: '',
					sEDDT: '',
					sEDDTOld: ''
				},
				
				dataRule: {
					sEDDT:[{
						required: true,
						message: '请选择到期时间',
						trigger: ['blur', 'change'],
					}],
				},
				
				showEditTime :false,
				//新增家长借阅时间
				showJYTime :false,
				ruleJYForm: {
					sHAAID:'',//家长ID
					sHAAPHON: '', //家长电话
					sHABID:'', //宝宝ID
					sHABNAME: '', //宝宝名称
					optionsHAB: [],
					sSAAID:'', //幼儿园ID
					sSAANAME: '' ,//所属幼儿园
					optionsSAA: [],
					sEDDTOld: '', //修改前
					sEDDT: '' //修改后
				},
				dataJYRule: {
					sHAAPHON:[{
						required: true,
						// message: '请输入家长电话',
						trigger: ['blur'],
						validator: checkPhone
					}],
					sHABNAME:[{
						required: true,
						message: '请选择宝宝姓名',
						trigger: ['blur', 'change'],
					}],
					sSAANAME:[{
						required: true,
						message: '请选择所属幼儿园',
						trigger: ['blur', 'change'],
					}],
					sEDDTOld:[{
						required: true,
						message: '请选择修改前借阅到期时间',
						trigger: ['blur', 'change'],
					}],
					sEDDT:[{
						required: true,
						message: '请选择修改后借阅到期时间',
						trigger: ['blur', 'change'],
					}],
				}
			};
		},
		created() {
			const end = new Date(+new Date(new Date().toLocaleDateString()) + 24 * 60 * 60 * 1000 - 1);
			const start = new Date(end.getFullYear(), end.getMonth(), 1);
			this.query.time[0] = formatTimeToStr(start, 'yyyy-MM-dd hh:mm');
			this.query.time[1] = formatTimeToStr(end, 'yyyy-MM-dd hh:mm');
			
			let curpagenum = this.query.pageIndex; //当前页码
			this.getBookState();
			this.getSAA();
			this.getData(curpagenum); //获取当前列表数据
			this.GetMCAListCount(); //获取当前列表条数
			
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			handleInput(e) {
				console.log(e)
				if(e === ''){
					this.clearFrom();
				}
			},
			//清空其他表单
			clearFrom(){
				this.ruleJYForm.sHAAID="";
				this.ruleJYForm.sHABID="";
				this.ruleJYForm.sHABNAME="";
				this.ruleJYForm.optionsHAB=[];
				this.ruleJYForm.sEDDTOld="";
				this.ruleJYForm.sEDDT="";
			},
			//选择宝宝姓名事件
			changeHAB(value){
				this.ruleJYForm.sHABID = value;
				this.checkMCA();
				// this.getSAANAME();
			},
			//选择幼儿园事件
			changeSAA(value){
				this.ruleJYForm.sSAAID = value;
				// console.log("--选择幼儿园事件--ID--" + value)
				this.ruleJYForm.sHAAPHON = "";
				this.clearFrom();
			},
			//校验此家长是否有缴费记录
			checkMCA() {
				console.log("--家长ID--" + this.ruleJYForm.sHAAID)
				console.log("--宝宝ID--" + this.ruleJYForm.sHABID)
				console.log("--幼儿园ID--" + this.ruleJYForm.sSAAID)
				
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcMCA.svc/CHECK_MCA';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sHAAI: this.ruleJYForm.sHAAID, //家长ID
						sHABI: this.ruleJYForm.sHABID, //宝宝ID
						sSAAI: this.ruleJYForm.sSAAID //幼儿园ID
					}
				)
				.then((response) => {
					let retStr = response.data.KKSTR;
					console.log("--校验此家长是否有缴费记录--" + retStr)
					//请求成功返回的数据
					this.ruleJYForm.sEDDTOld = '';
					if (retStr.indexOf("Y")!=-1) {
						//有缴费记录 显示此家长绘本到期时间
						this.ruleJYForm.sEDDTOld = retStr.split('||')[1];				
						// console.log("--有缴费记录--" + this.ruleJYForm.sEDDTOld);
					} else {
						//无记录 则显示当前时间
						this.ruleJYForm.sEDDTOld = this.GetDate();				
						// console.log("--无记录--" + this.ruleJYForm.sEDDTOld);
					}	
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			GetDate(){
			   var date = new Date();
			   var sign2 = ":";
			   var year = date.getFullYear() // 年
			   var month = date.getMonth() + 1; // 月
			   var day = date.getDate(); // 日
			   var hour = date.getHours(); // 时
			   var minutes = date.getMinutes(); // 分
			   var seconds = date.getSeconds() //秒
			   var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
			   var week = weekArr[date.getDay()];
			   // 给一位数的数据前面加 “0”
			   if (month >= 1 && month <= 9) {
			     month = "0" + month;
			   }
			   if (day >= 0 && day <= 9) {
			     day = "0" + day;
			   }
			   if (hour >= 0 && hour <= 9) {
			     hour = "0" + hour;
			   }
			   if (minutes >= 0 && minutes <= 9) {
			     minutes = "0" + minutes;
			   }
		
			   return year + "-" + month + "-" + day + " " + hour + sign2 + minutes;
			},
			//根据幼儿园ID和家长ID 获取宝宝名称
			getHABNAME(){
				const that = this;
				var postUrl='WCF/WEB/svcMCA.svc/GET_HAB_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSAAID: this.ruleJYForm.sSAAID, //幼儿园ID
						sHAAID: this.ruleJYForm.sHAAID //家长ID
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.ruleJYForm.optionsHAB = response.data.KKDT;
						if(this.ruleJYForm.optionsHAB.length === 1)
						{
							this.ruleJYForm.sHABID = response.data.KKDT[0].HABMSID;
							this.ruleJYForm.sHABNAME = response.data.KKDT[0].HABNAME;
							
							this.checkMCA();
						}
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//获取所属幼儿园
			getSAANAME(){
				const that = this;
				var postUrl='WCF/WEB/svcMAA.svc/Get_SAA_INI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsSBASAAI = response.data.KKDT;
							this.ruleJYForm.optionsSAA = response.data.KKDT;
							
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
				// console.log("--宝宝ID："+value)
				// const that = this;
				// var postUrl='WCF/WEB/svcMCA.svc/Get_SAA_NAME';
				// //网络请求接口
				// this.$axios.post(
				// 	//请求的url
				// 	postUrl,
				// 	//请求参数
				// 	{
				// 		sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
				// 		sHABID: value //宝宝ID
				// 	}
				// )
				// .then((response) => {
				// 	//请求成功返回的数据
				// 	let resCount = response.data.KKDTCOUNT;
				// 	if (resCount > 0) {
				// 		this.ruleJYForm.sSAANAME = '';
				// 		this.ruleJYForm.optionsSAA = [];
				// 		this.ruleJYForm.optionsSAA = response.data.KKDT;
						
				// 		if(this.ruleJYForm.optionsSAA.length === 1) //一个幼儿园
				// 		{
				// 			this.ruleJYForm.sSAAID = response.data.KKDT[0].SAAMSID;
				// 			this.ruleJYForm.sSAANAME = response.data.KKDT[0].SAANAME;
				// 			this.checkMCA();
				// 		}	
						
				// 		console.log("--幼儿园ID：--" + this.ruleJYForm.sSAAID);
				// 	}
				// })
				// .catch((error) => {
				// 	this.$message({
				// 		message: '请求失败', //请求失败
				// 		type: 'error'
				// 	});
				// });
			},
			//编辑
			editTime(formName){
				const self = this;
				
				// 二次确认删除
				self.$confirm('是否确认修改？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					self.$refs[formName].validate((valid) => {
						if (!valid) {
							self.$message({
								message: '提交失败', //表单验证失败
								type: 'error'
							});
							return;
						}
						var postUrl = 'WCF/WEB/svcMCA.svc/UpdateMCAInfo';
						//网络请求接口
						self.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
								sMSID: self.ruleForm.sMSID,
								sEDDT: self.ruleForm.sEDDT
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;
						
							if (resStatus == "200") {
								if (resKKSTR == "N") {
									self.$message({
										message: '修改失败', //新增失败
										type: 'error'
									});
								} else if (resKKSTR == "Y") {
									self.$message.success('修改成功'); // 操作成功
									self.showEditTime=false;
									
									// self.sellVisble = false;
									self.$refs['ruleForm'].resetFields()
									// self.reload();
									self.getData(this.query.pageIndex);
									self.GetMCAListCount();
								}
							} else {
								self.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							}
						})
						.catch((error) => {
							self.$message({
								message: '请求失败', //请求失败
								type: 'error'
							});
						});
					});
				});
			},
			changeTableSort (column) {
				var sortingType = column.order // ascending null "descending"
				if (sortingType === 'ascending') { // 升
					this.query.sort=column.prop+" ASC ";
				} else if (sortingType === 'descending') { // 降
					this.query.sort=column.prop+" DESC ";
				} 
				// 请求列表数据 sortParam
				this.getData(this.query.pageIndex);
			},
			/**
			 * @description 获取幼儿园信息
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSAA() {
				const that = this;
				var postUrl='WCF/WEB/svcMAA.svc/Get_SAA_INI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsSBASAAI = response.data.KKDT;						
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
			},
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//获取缴费状态
			getBookState() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10017 //缴费状态 10017
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsPayState = response.data.KKDT;
							response.data.KKDT.forEach((team, index) => {
								this.query.optionsPayState[index].INIDISP = team.INIDISP;
								this.query.optionsPayState[index].INIKEY2 = team.INIKEY2;
							})
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取借阅状态失败', //请求失败
							type: 'error'
						});
					});
			},
			// 日期格式化
			dateFormatter(row, column) {
				var t = new Date(row.HABBIRT); //row 表示一行数据, date 表示要格式化的字段名称
				var year = t.getFullYear(),
					month = t.getMonth() + 1,
					day = t.getDate();
				var newDate = year + '-' +
					(month < 10 ? '0' + month : month) + '-' +
					(day < 10 ? '0' + day : day);

				if (row.HABBIRT) {
					return newDate
				} else {
					return ''
				}
			},
			// 获取当前列表条数
			GetMCAListCount() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMCA.svc/GetMCAListCount';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sUPHON: self_count.query.uphon.trim(),
							sBNAME: self_count.query.bname.trim(),
							sSAAI: self_count.query.valueSABSAAI,
							sSTAT: self_count.query.valuePayState,
							sTIME: self_count.query.time
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						this.pageTotal = Number(resCount); //总条数
					})
					.catch((error) => {
						this.$message({
							message: '获取家长信息失败', //请求失败
							type: 'error'
						});
					});
			},
			// 设置预警颜色
			setCellColor: function (e) {  //{row,column,rowIndex,columnIndex}
				// console.log(e)
				if(e.columnIndex == 9){
					return 'color: ' + e.row.textColor;
				}
			},
			// 获取用户数据
			getData(curpage) {
				if(this.query.time[0] == null && this.query.time[1] == null && this.query.uphon.trim() == '' && this.query.bname.trim() == '' && this.query.valueSABSAAI == '' && this.query.valuePayState == ''){
					this.$message({
						message: '请至少录入一个检索条件', //请求失败
						type: 'error'
					});
					return;
				}
				
				if(this.query.time[0] == null && this.query.time[1] != null){
					this.$message({
						message: '请选择开始时间', //请求失败
						type: 'error'
					});
					return;
				}
				
				if(this.query.time[1] == null && this.query.time[0] != null){
					this.$message({
						message: '请选择结束时间', //请求失败
						type: 'error'
					});
					return;
				}
				
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcMCA.svc/GetMCAList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sPageIndex: curpage, //页码
							sPageSize: self_count.query.pageSize, //每页显示条数
							sSORT: self_count.query.sort,
							sUPHON: self_count.query.uphon.trim(),
							sBNAME: self_count.query.bname.trim(),
							sSAAI: self_count.query.valueSABSAAI,
							sSTAT: self_count.query.valuePayState,
							sTIME: self_count.query.time
						})
					.then((response) => {
						this.loading = false; //取消loading效果
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						let resKKDT = response.data.KKDT;
						if (resCount > 0) {
							//渲染数据 List
							resKKDT.forEach((item, index) => {
								if(item.MCBCZLX == '1'){
									item.textColor = "#00aa00";
								}
							})
							
							this.tableData = resKKDT; //数据数组
						} else {
							this.tableData = []; //数据数组
						}
					})
					.catch((error) => {
						this.loading = false; //取消loading效果
						this.$message({
							message: '获取缴费信息失败', //请求失败
							type: 'error'
						});
					});

			},
			// 触发搜索按钮
			handleSearch() {
				this.$set(this.query, 'pageIndex', 1);

				this.getData(1);
				this.GetMCAListCount(); //获取当前列表条数
			},
			// 触发打印
			exportExcel() {
				const self_count = this;
				
				var postUrl = 'WCF/WEB/svcMCA.svc/ExportMCAList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sUPHON: self_count.query.uphon.trim(),
						sBNAME: self_count.query.bname.trim(),
						sSAAI: self_count.query.valueSABSAAI,
						sSTAT: self_count.query.valuePayState,
						sTIME: self_count.query.time
					})
				.then((response) => {
					console.log(response)
					let restr=response.data.ExportMCAListResult;
					if (restr!='')
					{
						window.open(this.basehtmlURL + restr);
					}else{
						this.$message({
							message: '导出失败', //请求失败
							type: 'error'
						});
						
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			// 触发新增按钮
			handleAdd() {
				this.$router.push('/addBook'); // 跳转路由
			},
			// 查看操作
			handleView(index, row){
				this.idx = index;
				// 跳转路由
				this.$router.push({
					name: 'editBook',
					query: {
						MAAMSID: row.MAAMSID,
						flag: 'view'
					}
				})
			},
			// 编辑操作
			handleEdit(index, row) {
				var self = this;
				
				if(row.SAAQXKQ != '1'){
					this.$confirm('绘本收费计时暂未开启，不能修改到期时间', '提示', {
						confirmButtonText: '确定',
						showCancelButton:false,
						type: 'warning'
						}).then(() => {
							
						}).catch(() => {
					});
					return;
				}else{
					var postUrl = 'WCF/WEB/svcMCA.svc/CheckMCAList';
					//网络请求接口
					self.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
							sMSID: row.MCAMSID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status; //200 代表请求成功
						let resKKSTR = response.data.KKSTR;
					
						if (resStatus == "200") {
							if (resKKSTR == "N") {
								self.$message({
									message: '当前家长,宝宝或幼儿园已失效,无法修改绘本到期时间。', //新增失败
									type: 'error'
								});
								return;
							} else if (resKKSTR == "Y") {
								self.ruleForm.sMSID = row.MCAMSID;
								self.ruleForm.sEDDT = row.MCAEDDT;
								self.ruleForm.sEDDTOld = row.MCAEDDT;
								self.showEditTime = true;
							}
						} else {
							self.$message({
								message: '请求失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						self.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					});
				}
				// this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(1);
			},
			getRowKeys(row) {
				return row.HABMSID; // id为列表数据的唯一标识
			},
			handleAddJYTime()
			{
				this.showJYTime = true;

				this.ruleJYForm.sSAAID = '';
				this.ruleJYForm.sSAANAME = '';
				this.ruleJYForm.optionsSAA = [];
				
				this.ruleJYForm.sHAAPHON = "";
				
				this.clearFrom();
				this.getSAANAME();
			},
			onClose() {
			  this.showJYTime = false;
			  this.$refs['ruleJYForm'].resetFields()
			  this.ruleJYForm.optionsHAB = [];
			  this.ruleJYForm.optionsSAA = [];
			},
			//新增家长借阅时间 保存
			editJYTime(formName){
				const self = this;
				
				self.$refs[formName].validate((valid) => {
					if (valid) {
						// 二次确认
						self.$confirm('是否确认新增家长借阅时间？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							var postUrl = 'WCF/WEB/svcMCA.svc/AddMCAMCB';
							//网络请求接口
							self.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sHAAI: self.ruleJYForm.sHAAID, //家长ID
									sHABI: self.ruleJYForm.sHABID, //宝宝ID
									sSAAI: self.ruleJYForm.sSAAID, //幼儿园ID
									sEDDTOld: self.ruleJYForm.sEDDTOld,//修改前借阅到期时间
									sEDDT: self.ruleJYForm.sEDDT //修改后借阅到期时间
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;
							
								if (resStatus == "200") {
									if (resKKSTR == "N") {
										self.$message({
											message: '新增失败', //新增失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										self.$message.success('操作成功'); // 操作成功
										self.showJYTime=false;
							
										self.getData(this.query.pageIndex);
										self.GetMCAListCount();
									}
								} else {
									self.$message({
										message: '请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								self.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							});
						});
					}
				});
			}
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
